import { IChatSession, IChatMessage, IChatPreference } from 'src/interface/IChatState';
import { appAxios } from './appAxios';

const CHAT_API_BASE = 'v1/chat';

export class ChatApi {
  // Sessions
  static async getSessions(): Promise<IChatSession[]> {
    const response = await appAxios.get(`${CHAT_API_BASE}/sessions`);
    return response.data.items || [];
  }

  static async createSession(language = 'vi'): Promise<IChatSession> {
    const response = await appAxios.post(`${CHAT_API_BASE}/sessions`, { language });
    return response.data;
  }

  static async getSession(sessionId: string): Promise<IChatSession> {
    const response = await appAxios.get(`${CHAT_API_BASE}/sessions/${sessionId}`);
    return response.data;
  }

  static async archiveSession(sessionId: string): Promise<void> {
    await appAxios.delete(`${CHAT_API_BASE}/sessions/${sessionId}`);
  }

  // Messages
  static async getMessages(sessionId: string, page = 1, perPage = 50): Promise<IChatMessage[]> {
    const response = await appAxios.get(`${CHAT_API_BASE}/sessions/${sessionId}/messages`, {
      params: { page, per_page: perPage }
    });
    return response.data.items || [];
  }

  static async sendMessage(
    sessionId: string,
    content: string,
    language = 'vi',
    pageContext?: any
  ): Promise<IChatMessage> {
    const response = await appAxios.post(`${CHAT_API_BASE}/sessions/${sessionId}/messages`, {
      content,
      language,
      page_context: pageContext
    });
    return response.data;
  }

  // Preferences
  static async getPreferences(): Promise<IChatPreference> {
    const response = await appAxios.get(`${CHAT_API_BASE}/preferences`);
    return response.data;
  }

  static async updatePreferences(preferences: Partial<IChatPreference>): Promise<IChatPreference> {
    const response = await appAxios.put(`${CHAT_API_BASE}/preferences`, preferences);
    return response.data;
  }

  // Context (for context-aware features in Phase 5)
  static async updateContext(sessionId: string, contextData: Record<string, any>): Promise<void> {
    await appAxios.post(`${CHAT_API_BASE}/sessions/${sessionId}/context`, contextData);
  }
}

export default ChatApi;
